export interface FiltrosProps {
  type_user: any;
  setType_user: any;
  agencySelect: any;
  setAgencySelect: any;
  representanteSelect: any;
  setRepresentanteSelect: any;
  setMes: any;
  mes: any;
  representadoSelect: any;
  setRepresentadoSelect: any;
  regiaoSelect: any;
  setRegiaoSelect: any;
  areaSelecionada: any;
  setAreaSelecionada: any;
  cargoSelecionado: any;
  setCargoSelecionado: any;
  openFilters: boolean;
  setOpenFilters: any;
  currentPage?: number;
  setCurrentPage: any;
  cargos: any;
  setCargos: any;

  idMenu: any;
  mesAtual: any;
}

export interface MesesProps {
  value: string;
  label: string;
}

export const MesesList: Array<MesesProps> = [
  { value: "Jan", label: "Janeiro" },
  { value: "Feb", label: "Fevereiro" },
  { value: "Mar", label: "Março" },
  { value: "Apr", label: "Abril" },
  { value: "May", label: "Maio" },
  { value: "Jun", label: "Junho" },
  { value: "Jul", label: "Julho" },
  { value: "Aug", label: "Agosto" },
  { value: "Sep", label: "Setembro" },
  { value: "Oct", label: "Outubro" },
  { value: "Nov", label: "Novembro" },
  { value: "Dec", label: "Dezembro" },
];
